module.exports = __webpack_public_path__ + "static/media/armandthiery.4ecfc024.svg";